import { render, staticRenderFns } from "./interactive-info-create.vue?vue&type=template&id=52b2c17a&"
import script from "./interactive-info-create.vue?vue&type=script&lang=js&"
export * from "./interactive-info-create.vue?vue&type=script&lang=js&"
import style0 from "./interactive-info-create.vue?vue&type=style&index=0&id=52b2c17a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports